export const servicesTypes = [
  { value: '', label: 'Não informado' },
  { value: 'auth', label: 'Serviço de autenticação' },
  { value: 'delivery', label: 'Serviço de entregas' },
  { value: 'payment', label: 'Serviço de pagamento' },
];
